import Checkbox from "../../../components/checkbox/checkbox";
//import { isAuthenticated } from "../../../auth/auth";
import FormActionButton from "../../../components/formActionButton/formActionButton";
import PillTitle from "../../../components/pillTitle/pillTitle";
import { useI18n } from "../../../utils/translate/i18n/useI18n";
import { useNavigate } from "react-router-dom";
import "./testParameters.scss";
import type { TonalTestParametersContentProps, TonalTestParametersProps } from "../../../type/tonalTest";

export function TestParametersContent({
  addNoise,
  continuous,
  randomTest,
  adaptiveTest,
  onToggleAddNoise,
  onToggleContinuous,
  onToggleRandomTest,
  onToggleAdaptiveTest,
  locked = false,
}: TonalTestParametersContentProps) {
  const { t } = useI18n();
  const isAddNoiseDisabled = locked || randomTest;

  return (
    <div className="panel--parameters--container">
      <div className="panel--parameters--checkboxplace">
        <Checkbox
          label={t("Dodaj szum")}
          description={t("Odtwarza szum tła podczas testu, aby zwiększyć dokładność pomiaru.")}
          checked={addNoise}
          onChange={onToggleAddNoise}
          disabled={isAddNoiseDisabled}
          variant="compact"
          icon="bi-soundwave"
          infoTitle={t("Dodaj szum - informacja")}
          infoText={t("Dodaj szum check info")}
        />
      </div>
      <div className="panel--parameters--checkboxplace">
        <Checkbox
          label={t("Dźwięk ciągły")}
          description={t("Odtwarza dźwięk ciągły podczas testu.")}
          checked={continuous}
          onChange={onToggleContinuous}
          disabled={locked}
          variant="compact"
          icon="bi-volume-up-fill"
        />
      </div>
      <div className="panel--parameters--checkboxplace">
        <Checkbox
          label={t("Losowy test")}
          description={t("Losowo przełącza uszy podczas badania.")}
          checked={randomTest}
          onChange={onToggleRandomTest}
          disabled={locked}
          variant="compact"
          icon="bi-shuffle"
          infoTitle={t("Losowy test - informacja")}
          infoText={t("Losowy test check info")}
        />
      </div>
      <div className="panel--parameters--checkboxplace">
        <Checkbox
          label={t("Test adaptacyjny")}
          description={t("Automatycznie dostosowuje poziom dźwięku do Twoich odpowiedzi, precyzyjniej wyznaczając próg słyszenia.")}
          checked={adaptiveTest}
          onChange={onToggleAdaptiveTest}
          disabled={locked}
          variant="compact"
          icon="bi-activity"
          infoTitle={t("Test adaptacyjny - informacja")}
          infoText={t("Adaptacyjny test słuchu to badanie, w którym poziom głośności dźwięku automatycznie dostosowuje się do odpowiedzi badanego. Test rozpoczyna się zwykle od poziomu 30 dB, a następnie dźwięki są ściszane lub wzmacniane w zależności od tego, czy badana osoba je usłyszy. Dodatkowo test wykorzystuje losowo dobierane częstotliwości, co zwiększa wiarygodność wyników i pozwala dokładniej określić próg słyszenia.")}
        />
      </div>
    </div>
  );
}

export default function TestParameters({
  step,
  addNoise,
  continuous,
  randomTest,
  adaptiveTest,
  gender,
  ageCategory,
  onToggleAddNoise,
  onToggleContinuous,
  onToggleRandomTest,
  onToggleAdaptiveTest,
  onChangeGender,
  onChangeAgeCategory
}: TonalTestParametersProps) {
  const { t } = useI18n();
  const navigate = useNavigate();
  const isLocked = step !== "params";
  const isGuest = false; //!isAuthenticated();

  return (
    <div className={`panel panel--light panel--parameters card border-0 mt-3${isLocked ? " panel--parameters--locked" : ""}`}>
      {isGuest ? (
        <div className="card-body panel--parameters__guest">
          <div className="panel--parameters__guest-hero" aria-hidden="true">
            <i className="bi bi-person-lock panel--parameters__guest-icon" />
          </div>
          <p className="panel--parameters__guest-note">
            <b>{t("Nie jesteś zalogowany.")}</b><br />
            {t("Po zalogowaniu zyskasz dostęp do historii swoich wyników, dodatkowych opcj oraz możliwości personalizacji aplikacji. Dzięki temu możliwe jest korzystanie z rozszerzonych funkcji.")}
          </p>
          <FormActionButton
            className="form-action-button form-action-button--secondary form-action-button--sm"
            iconClassName="bi bi-box-arrow-in-right"
            onClick={() => navigate("/login")}
          >
            {t("Zaloguj")}
          </FormActionButton>
        </div>
      ) : (
        <div className="card-body text-start panel--parameters__main">
          <PillTitle as="div" variant="blue-brighter" iconClassName="bi bi-sliders2" text={t("Parametry testu")} />
          <TestParametersContent
            addNoise={addNoise}
            continuous={continuous}
            randomTest={randomTest}
            adaptiveTest={adaptiveTest}
            gender={gender}
            ageCategory={ageCategory}
            onToggleAddNoise={onToggleAddNoise}
            onToggleContinuous={onToggleContinuous}
            onToggleRandomTest={onToggleRandomTest}
            onToggleAdaptiveTest={onToggleAdaptiveTest}
            onChangeGender={onChangeGender}
            onChangeAgeCategory={onChangeAgeCategory}
            locked={isLocked}
          />
        </div>
      )}
    </div>
  );
}